import { createDiv, createPara, createSVG, createTextField } from "../utils/utils";
import loadAuthPage from "../pages/AuthPage";
import {signOut} from "firebase/auth";
import { auth } from "../firebase"; 

export default function sidebar(){

    const root = document.querySelector(".container"); 
    root.innerHTML = "";
    const getSidebar = createDiv(root,"sidebar"); 

    const getSidebarHeader = createDiv(getSidebar,"sidebar-header");
    createPara(getSidebarHeader,"sidebar-title","Menu");
    const getSidebarMenu = createSVG(getSidebarHeader,"sidebar-hamburger-menu-svg","M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z");


    const getSidebarSearch = createDiv(getSidebar,"sidebar-search");
    createSVG(getSidebarSearch,"sidebar-search-svg", "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z");
    const getSearchTextField = createTextField(getSidebarSearch,"sidebar-search-textfield","Search","text");

    const getSidebarTaskMain = createDiv(getSidebar,"sidebar-tasks-main");
    createPara(getSidebarTaskMain,"sidebar-task-title","TASKS");

    const getSidebarUpcomingTasks = createDiv(getSidebarTaskMain,"sidebar-upcoming-tasks");
    const getUpcomingTaskSvgTitle = createDiv(getSidebarUpcomingTasks,"upcoming-task-svg-title");
    createSVG(getUpcomingTaskSvgTitle,"upcoming-svg", "M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z");
    createPara(getUpcomingTaskSvgTitle,"upcoming-title","Upcoming");
    const getUpcomingTaskCount = createDiv(getSidebarUpcomingTasks,"task-count");
    createPara(getUpcomingTaskCount,"upcoming-count","0");

    const getSidebarTodayTasks = createDiv(getSidebarTaskMain,"sidebar-today-tasks");
    const getTodayTaskSvgTitle = createDiv(getSidebarTodayTasks,"today-task-svg-title");
    createSVG(getTodayTaskSvgTitle,"today-svg", "M4 13C2.89 13 2 13.89 2 15V19C2 20.11 2.89 21 4 21H8C9.11 21 10 20.11 10 19V15C10 13.89 9.11 13 8 13M8.2 14.5L9.26 15.55L5.27 19.5L2.74 16.95L3.81 15.9L5.28 17.39M4 3C2.89 3 2 3.89 2 5V9C2 10.11 2.89 11 4 11H8C9.11 11 10 10.11 10 9V5C10 3.89 9.11 3 8 3M4 5H8V9H4M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12Z");
    createPara(getTodayTaskSvgTitle,"today-title","Today");
    const getTodayTaskCount = createDiv(getSidebarTodayTasks,"task-count");
    createPara(getTodayTaskCount,"today-count","0");

    const getSidebarPastTasks = createDiv(getSidebarTaskMain,"sidebar-past-tasks");
    const getPastTaskSvgTitle = createDiv(getSidebarPastTasks,"past-task-svg-title");
    createSVG(getPastTaskSvgTitle,"past-svg", "M18 22H6V16L10 12L6 8V2H18V8L14 12L18 16M8 7.5L12 11.5L16 7.5V4H8M12 12.5L8 16.5V20H16V16.5M14 18H10V17.2L12 15.2L14 17.2Z");
    createPara(getPastTaskSvgTitle,"past-title","Past");
    const getPastTaskCount = createDiv(getSidebarPastTasks,"task-count");
    createPara(getPastTaskCount,"past-count","0");

    createDiv(getSidebar,"sidebar-h-line");

    const getSidebarListMain = createDiv(getSidebar,"sidebar-list-main");
    createPara(getSidebarListMain,"sidebar-lists-title","PRIORITY");

    const getSidebarHighTaskList = createDiv(getSidebarListMain,"sidebar-high-tasks");
    const getHighTaskLogoTitle = createDiv(getSidebarHighTaskList,"high-task-logo-title");
    createDiv(getHighTaskLogoTitle,"high-task-logo");
    createPara(getHighTaskLogoTitle,"high-task-title","High");
    const getHighTaskCount = createDiv(getSidebarHighTaskList,"task-count");
    createPara(getHighTaskCount,"high-count","0");

    const getSidebarNormalTaskList = createDiv(getSidebarListMain,"sidebar-normal-tasks");
    const getNormalTaskLogoTitle = createDiv(getSidebarNormalTaskList,"normal-task-logo-title");
    createDiv(getNormalTaskLogoTitle,"normal-task-logo");
    createPara(getNormalTaskLogoTitle,"normal-task-title","Normal");
    const getNormalTaskCount = createDiv(getSidebarNormalTaskList,"task-count");
    createPara(getNormalTaskCount,"normal-count","0");

    const getSidebarLowTaskList = createDiv(getSidebarListMain,"sidebar-low-tasks");
    const getLowTaskLogoTitle = createDiv(getSidebarLowTaskList,"low-task-logo-title");
    createDiv(getLowTaskLogoTitle,"low-task-logo");
    createPara(getLowTaskLogoTitle,"low-task-title","Low");
    const getLowTaskCount = createDiv(getSidebarLowTaskList,"task-count");
    createPara(getLowTaskCount,"low-count","0");

    createDiv(getSidebar,"sidebar-h-line");
    
    const getSidebarFooter = createDiv(getSidebar,"sidebar-footer");

    const getSidebarSetting = createDiv(getSidebarFooter,"sidebar-setting");
    createSVG(getSidebarSetting,"setting-svg","M7.5,2C5.71,3.15 4.5,5.18 4.5,7.5C4.5,9.82 5.71,11.85 7.53,13C4.46,13 2,10.54 2,7.5A5.5,5.5 0 0,1 7.5,2M19.07,3.5L20.5,4.93L4.93,20.5L3.5,19.07L19.07,3.5M12.89,5.93L11.41,5L9.97,6L10.39,4.3L9,3.24L10.75,3.12L11.33,1.47L12,3.1L13.73,3.13L12.38,4.26L12.89,5.93M9.59,9.54L8.43,8.81L7.31,9.59L7.65,8.27L6.56,7.44L7.92,7.35L8.37,6.06L8.88,7.33L10.24,7.36L9.19,8.23L9.59,9.54M19,13.5A5.5,5.5 0 0,1 13.5,19C12.28,19 11.15,18.6 10.24,17.93L17.93,10.24C18.6,11.15 19,12.28 19,13.5M14.6,20.08L17.37,18.93L17.13,22.28L14.6,20.08M18.93,17.38L20.08,14.61L22.28,17.15L18.93,17.38M20.08,12.42L18.94,9.64L22.28,9.88L20.08,12.42M9.63,18.93L12.4,20.08L9.87,22.27L9.63,18.93Z");
    let getDarkMode = createPara(getSidebarSetting,"setting-title","Dark Mode");

    const getAllSvgsInSidebar = document.querySelectorAll(".sidebar svg");
    const getAllTaskCountDivsInSidebar = document.querySelectorAll(".task-count");

    const getSidebarLogout = createDiv(getSidebarFooter,"sidebar-logout");
    const getLogOutSvg = createSVG(getSidebarLogout,"logout-svg", "M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12M4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z");
    createPara(getSidebarLogout,"logout-title","Sign Out");

    getSidebarSetting.addEventListener("click",()=>{
        root.classList.toggle("container-dark-mode");
        getSidebar.classList.toggle("sidebar-dark-mode");
        getSearchTextField.classList.toggle("sidebar-dark-mode");
        getSidebarHeader.classList.toggle("dark-mode-font-bright");
        getSidebarTaskMain.classList.toggle("dark-mode-font-bright");
        getSidebarListMain.classList.toggle("dark-mode-font-bright");
        getSidebarFooter.classList.toggle("dark-mode-font-bright");
        getLogOutSvg.classList.toggle("dark-mode-svg-fill");
        getAllSvgsInSidebar.forEach(svg => {
            svg.classList.toggle("dark-mode-svg-fill");
        });
        getAllTaskCountDivsInSidebar.forEach(count => {
            count.classList.toggle("dark-mode-font-dark");
        });
    });
    getSidebarLogout.addEventListener("click", async () => {
        try {
          await signOut(auth);
          alert("User signed out");
          root.innerHTML = "";
          root.classList.remove("container-dark-mode");
          loadAuthPage();
        } catch (error) {
          console.error("Error signing out:", error.message);
          alert("Failed to log out. Please try again.");
        }
      });
      
      addHoverEffect(".sidebar-upcoming-tasks, .sidebar-today-tasks, .sidebar-past-tasks, .sidebar-calendar, .sidebar-sticky-notes");
      addHoverEffect(".sidebar-high-tasks, .sidebar-normal-tasks, .sidebar-low-tasks, .sidebar-new-list");
      addHoverEffect(".sidebar-setting, .sidebar-logout");


    const getSidebarSelectedDiv = [getSidebarUpcomingTasks,getSidebarTodayTasks,getSidebarPastTasks,getSidebarHighTaskList,getSidebarNormalTaskList,getSidebarLowTaskList,getSidebarLogout];
    getSidebarTodayTasks.classList.add("selected-task");
    getSidebarTodayTasks.querySelector(".task-count").classList.add("selected-task-count");
    const dark = document.querySelector(".sidebar-setting");
    const getAllSvgs = document.querySelectorAll(".sidebar svg");
    let darkModeActive = false; // track whether dark mode is ON
      
      // Sidebar click handler
      function handleSidebarClick(element) {
        // remove all selections first
        getSidebarSelectedDiv.forEach(item => {
          item.classList.remove("selected-task", "selected-task2");
          item.querySelector(".task-count")?.classList.remove("selected-task-count");
        });
      
        // add based on mode
        if (darkModeActive) {
          getDarkMode.textContent = "Light Mode";
          element.classList.add("selected-task2");
        } else {
          getDarkMode.textContent = "Dark Mode";
          element.classList.add("selected-task");
        }
      
        element.querySelector(".task-count")?.classList.add("selected-task-count");
      }
      
      // Attach event listeners once
      getSidebarSelectedDiv.forEach(element => {
        element.addEventListener("click", () => handleSidebarClick(element));
      });
      
      // Dark mode toggle
      dark.addEventListener("click", () => {
        darkModeActive = !darkModeActive; // toggle state
        getDarkMode.textContent = darkModeActive ? "Light Mode" : "Dark Mode";
        // update currently selected item to switch its class
        const selected = document.querySelector(".selected-task, .selected-task2");
        if (selected) {
          selected.classList.remove("selected-task", "selected-task2");
          selected.classList.add(darkModeActive ? "selected-task2" : "selected-task");
        }
      });
      
}
function addHoverEffect(selectors) {
    const elements = document.querySelectorAll(selectors);
    const dark = document.querySelector(".sidebar-setting");
  
    let darkModeActive = false; // track dark mode state
  
    function applyHoverEffects() {
      elements.forEach(el => {
        el.onmouseenter = () => {
          el.classList.add(darkModeActive ? "hover-effect2" : "hover-effect");
        };
        el.onmouseleave = () => {
          el.classList.remove("hover-effect");
          el.classList.remove("hover-effect2");
        };
      });
    }
  
    // Initial hover setup (light mode)
    applyHoverEffects();
  
    // Toggle dark mode
    dark.addEventListener("click", () => {
      darkModeActive = !darkModeActive; // toggle state
      dark.classList.toggle("hover-effect2", darkModeActive);
      dark.classList.toggle("hover-effect", !darkModeActive);
  
      applyHoverEffects(); // reapply with updated mode
    });
}
  